import { GhostText } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostTypography";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import React, { Fragment } from "react";
import styled from "styled-components";

const NUM_FILTER_SECTIONS = 3;
const NUM_SIDENAV_CATEGORIES = 10;

interface IProps {
  hideSideNav?: boolean;
  filterCount?: number;
}

export const FilterSideBarLoadingSkeleton: React.FC<IProps> = ({
  hideSideNav,
  filterCount,
}) => (
  <SidebarContainerWithFilters>
    {hideSideNav ? null : (
      <>
        <GhostText />
        <Spacer width="2x" />
        <Column style={{ paddingLeft: getSpacing("2x") }}>
          {Array.from({ length: NUM_SIDENAV_CATEGORIES }).map((_, index) => (
            <Fragment key={index}>
              <FilterPlaceholder />
              <Spacer width="2x" />
            </Fragment>
          ))}
        </Column>
        <HorizontalLine />
      </>
    )}
    {Array.from({ length: filterCount ?? NUM_FILTER_SECTIONS }).map(
      (_, index) => (
        <Fragment key={index}>
          <Spacer width="3x" />
          <GhostText />
          <Spacer width="3x" />
          <HorizontalLine />
        </Fragment>
      )
    )}
  </SidebarContainerWithFilters>
);

const SidebarContainerWithFilters = styled(Column)`
  flex: 0 0 228px;
  margin-right: ${getSpacing("6x")};
`;

const FilterPlaceholder = styled(GhostText)`
  padding: 10px;
`;
